<template>
  <div @click="sendStatistic" v-if="isDesktopIframe" class="iframe_ad"
       v-html="ad.iframe_code" :class="{'js-code':isJsCode}"></div>

  <div @click="sendStatistic" v-else-if="isMobileIframe" class="iframe_ad"
       v-html="ad.mobile_iframe" :class="{'js-code':isJsCode}"></div>


  <div v-else-if="!ad.link" class="image_ad">
      <img :src="getImage">
  </div>

  <a @click="sendStatistic" v-else class="image_ad" :href="ad.link" target="_blank">
    <img :src="getImage">
  </a>
</template>

<script>
import getBaseUrl from "@/helpers/getBaseUrl";
import ad from "@/mixins/ad"
import {mapActions} from "vuex";

export default {
  data: () => ({
    iframeWidth: null,
    iframeHeight: null,
    isJsCode: false
  }),
  mixins: [ad],
  props: {
    ad: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mounted() {
    console.log("mounted ad");
    setTimeout(() => {
      this.setIframe();
    }, 100);
    window.addEventListener('resize', () => {
      this.setIframe();
    }, true);
  },
  methods: {
    ...mapActions({
      adStatistic: 'ad/SEND_STATISTIC'
    }),
    setIframe() {
      this.isJsCode = this.loadScript();
      if (this.$device.mobile()) {
        return;
      }

      let image_ad = document.querySelector(".image_ad");
      if (!image_ad) {
        return;
      } else {
        //console.log(image_ad.clientWidth);
        //console.log(image_ad.clientHeight);
      }

      let elem = document.querySelector(".iframe_ad");
      if (!elem) {
        return;
      }

      let windowWidth = window.innerWidth;
      let elemIframe = document.querySelector(".iframe_ad.left-ad-main > iframe");
      if(elemIframe) {
        //let width = elem.clientWidth;
        if (elemIframe && !this.iframeWidth && !this.iframeHeight) {
          this.iframeWidth = elemIframe.width;
          this.iframeHeight = elemIframe.height;
        }

        if (windowWidth < 1200) {
          elemIframe.setAttribute('height', (this.iframeHeight) + 'px');
          elemIframe.setAttribute('width', '100%');
        } else {
          let calcWidth = windowWidth - document.querySelector(".filters").clientWidth - 450;
          let calcHeight = (calcWidth / (this.iframeWidth / this.iframeHeight));

          elemIframe.setAttribute('height', (parseInt(calcHeight)) + 'px');
          elemIframe.setAttribute('width', calcWidth + 'px');
        }
      }
    },
    sendStatistic() {
      this.adStatistic({id: this.ad.id});
    }
  },
  computed: {
    isDesktopIframe(){
      return !!this.ad.iframe_code && !this.$device.mobile()
    },
    isMobileIframe(){
      return !!this.$device.mobile() && this.ad.mobile_iframe
    },
    getImage() {
      if (!this.ad.img_mobile && !this.ad.img_desktop) {
        return false;
      }

      return getBaseUrl() + '/img/rec/' + (this.$device.mobile() ? this.ad.img_mobile : this.ad.img_desktop);
    }
  }
}
</script>


<style lang="less">
.image_ad:not(.right-ad-main) {
  img {
    width: 100%;
    //height: 88%;
  }
}
</style>
